'use client';

import type { IStepPlainCount } from '@repo/sdk';
import { Badge } from '@repo/ui';
import type { JSX } from 'react';

interface IPipelineStepPlainCountBadgeProps {
  step: IStepPlainCount;
}

export function PipelineStepPlainCountBadge({
  step,
}: IPipelineStepPlainCountBadgeProps): JSX.Element {
  if (step.count === 0) {
    return (
      <Badge variant="outline" className="text-muted-foreground">
        -
      </Badge>
    );
  }

  return (
    <Badge variant="secondary" className="gap-1">
      {step.count}
    </Badge>
  );
}
